// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kx-2";
export var container = "_kx-4";
export var dismissButton = "_kx-3";
export var hasPaddingBottom = "_kx-6";
export var last = "_kx-e";
export var scrollbarThumb = "_kx-c";
export var scrollbarTrack = "_kx-b";
export var selected = "_kx-9";
export var spin = "_kx-1";
export var spinning = "_kx-0";
export var suggestionItem = "_kx-d";
export var suggestionsPanel = "_kx-5";
export var tonePill = "_kx-8";
export var tonesContainer = "_kx-7";
export var unselected = "_kx-a";